import { render, staticRenderFns } from "./formA-G.vue?vue&type=template&id=59717780&scoped=true&"
import script from "./formA-G.vue?vue&type=script&lang=js&"
export * from "./formA-G.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59717780",
  null
  
)

export default component.exports